/**
 * Get Sync Status Use Case
 */

import { SyncStatusEntity } from "../../../../../compliance/domain/entities";
import { TenantComplianceRepository } from "../../../../../compliance/domain/repositories";

export class GetSyncStatusUseCase {
  constructor(private repository: TenantComplianceRepository) {}

  async execute(): Promise<SyncStatusEntity> {
    return await this.repository.getSyncStatus();
  }
}

